// extracted by mini-css-extract-plugin
module.exports = {"container":"zUIQm","title":"_1k-3l"};